import { render } from "./modelo_fei_estoque.vue?vue&type=template&id=8123beda&scoped=true"
import script from "./modelo_fei_estoque.vue?vue&type=script&lang=js"
export * from "./modelo_fei_estoque.vue?vue&type=script&lang=js"

import "./modelo_fei_estoque.vue?vue&type=style&index=0&id=8123beda&scoped=true&lang=css"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8123beda"]])

export default __exports__